import React, { useState } from "react";
import { Grid } from "@mui/material";
import { IoAdd } from "react-icons/io5";
import { find } from "lodash";

import Button from "../../../../../components/Button-v2";
import Table from "../../../subcomponents/Table";
import Input from "../../ReadOnlyInput";
import OpinionsModal from "../modal/OpinionsModal";
import StatusModal from "../modal/StatusModal";
import { timeStampToDateWithTimeUtc } from "../../../../../utils/formats";
import { AddButtonWrapper, Separator } from "../styled";
import { isLoggedUser } from "../../../../../utils/permissions";

const style = {
  justify: "center",
};

const decisions = [
  { value: 1, description: "Favorável" },
  { value: 2, description: "Desfavorável" },
  { value: 3, description: "Não se aplica" },
];

export const parseDecisionType = (value, id, entry) => {
  return find(decisions, (it) => it.value === value)?.description;
};

const opinionsColumns = [
  { id: "numeroSequencia", name: "Seq.", style: { ...style, width: "100px" } },
  { id: "descricaoTipo", name: "Tipo de parecer" },
  {
    id: "codidoTipoDecisao",
    name: "Decisão",
    render: parseDecisionType,
    style: { ...style, width: "150px" },
  },
];

const OpinionsSection = (props) => {
  const [opinionModalOpen, setOpinionModalOpen] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedOpinion, setSelectedOpinion] = useState(undefined);

  const {
    cpfCnpj,
    proposalNumber,
    opinions,
    opinionsLoading,
    opinionTypes,
    opinionTypesLoading,
    reloadOpinions,
    reloadEvents,
    proposalPossibleStatuses,
    proposalPossibleStatusesLoading,
    reloadProposalPossibleStatuses,
    cpfAnalista,
    proposalGroupCode,
  } = props;

  return (
    <>
      <AddButtonWrapper>
        <Button
          height="35px"
          minWidth="215px"
          fontSize="11px"
          type="button"
          onClick={() => setOpinionModalOpen(true)}
          leftIcon={IoAdd}
          disabled={!isLoggedUser(cpfAnalista)}
        >
          Adicionar parecer
        </Button>
      </AddButtonWrapper>
      <Separator />
      <Grid container spacing={1}>
        <Grid item xs={12} md={7}>
          <Table
            loadingRows={5}
            noDataMessage="Sem dados"
            columns={opinionsColumns}
            loading={opinionsLoading}
            entries={opinions}
            onRowClick={setSelectedOpinion}
            selectedRow={selectedOpinion}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
              <Input
                color="#f6f6f6"
                label="Nome Usuário"
                loading={opinionsLoading}
                value={selectedOpinion?.nomeUsuario}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                color="#f6f6f6"
                label="Data/Hora"
                loading={opinionsLoading}
                value={timeStampToDateWithTimeUtc(
                  selectedOpinion?.dataInclusao
                )}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Input
                label="Parecer"
                height={150}
                align="flex-start"
                type="textarea"
                loading={opinionsLoading}
                value={selectedOpinion?.descricao}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <OpinionsModal
        open={opinionModalOpen}
        onClose={() => setOpinionModalOpen(false)}
        cpfCnpj={cpfCnpj}
        proposalNumber={proposalNumber}
        decisions={decisions}
        opinionTypes={opinionTypes}
        opinionTypesLoading={opinionTypesLoading}
        proposalPossibleStatuses={proposalPossibleStatuses}
        proposalPossibleStatusesLoading={proposalPossibleStatusesLoading}
        reloadOpinions={reloadOpinions}
        reloadEvents={reloadEvents}
        reloadProposalPossibleStatuses={reloadProposalPossibleStatuses}
        proposalGroupCode={proposalGroupCode}
      />
      <StatusModal
        open={statusModalOpen}
        onClose={() => setStatusModalOpen(false)}
      />
    </>
  );
};

export default OpinionsSection;
